import { useEffect, useState } from "react"
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance"
import Form from "../../../../Partials/Layouts/Forms/Form"
import ShortTextInput from "../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput"
import FormSubmitButton from "../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton"
import ImageInput from "../../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput"
import { MATERIAL_API } from "../../../../../Utilities/APIs/APIs"
import SwitchInput from "../../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput"

function UpdateMaterial({ targetID, triggerFetch, setShowUpdateForm }) {

    const axiosInstance = useAxiosInstance()

    const [name, setName] = useState('')
    const [image, setImage] = useState('')
    const [isActive, setIsActive] = useState('')

    useEffect(() => {
        async function fetchAndSetSingleMaterial() {
            const { data } = await axiosInstance.get(MATERIAL_API + 'getSingleMaterial/' + targetID)
            setName(data.name)
            setImage(data.image)
            setIsActive(data.isActive)
        }
        fetchAndSetSingleMaterial()

    }, [targetID, axiosInstance])

    async function handleSubmit(e) {

        e.preventDefault()
        const itemData = new FormData()

        itemData.append('name', name)
        itemData.append('image', image)
        itemData.append('isActive', isActive)

        const response = await axiosInstance.patch(MATERIAL_API + targetID, itemData)
        if (response) {
            triggerFetch()
            setShowUpdateForm(false)
        }
    }

    return (
        <div className='crate_form'>
            <Form onSubmit={handleSubmit}>
                <div>
                    <ShortTextInput
                        label={`Material Name`}
                        value={name}
                        placeholder={`Material Name`}
                        setState={setName}
                    />
                    <ImageInput
                        fieldId="1"
                        state={image}
                        setState={setImage}
                        allowUpdateImage
                    >
                        Upload Material Image
                    </ImageInput>
                    <SwitchInput
                        label={`Status`}
                        toggleSwitch={() => setIsActive(prevState => !prevState)}
                        checked={isActive}
                    />
                </div>
                <FormSubmitButton text="Submit" />
            </Form>
        </div>
    )
}

export default UpdateMaterial